// src/components/chat/ErrorMessage.tsx
import * as React from "react";
import { ErrorMessageProps } from "./types/ChatUITypes";

const ErrorMessage: React.FC<ErrorMessageProps> = ({ error, onDismiss }) => {
  if (!error) return null;

  // Self-contained error message styling - no external dependencies
  const errorContainerStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px",
    backgroundColor: "#fde7e9",
    borderRadius: "4px",
    color: "#d83b01",
    fontSize: "14px",
    fontFamily: "'Segoe UI', sans-serif",
    border: "1px solid #f1c0c3", // Subtle border for better definition
    boxShadow: "0 1px 3px rgba(216, 59, 1, 0.1)", // Light shadow for depth
  };

  const iconStyle: React.CSSProperties = {
    flexShrink: 0, // Prevent icon from shrinking if text is long
    display: "flex",
    alignItems: "center",
  };

  const closeButtonStyle: React.CSSProperties = {
    marginLeft: "auto",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "20px",
    height: "20px",
    cursor: "pointer",
    border: "none",
    background: "transparent",
    padding: "0",
    opacity: 0.7,
    transition: "opacity 0.2s",
  };

  return (
    <div style={errorContainerStyle} role="alert" aria-live="assertive">
      <div style={iconStyle} aria-hidden="true">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8" cy="8" r="7.5" stroke="#D83B01" />
          <path d="M8 4V9" stroke="#D83B01" strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="8" cy="11.5" r="1" fill="#D83B01" />
        </svg>
      </div>
      <span style={{ flex: 1 }}>{error}</span>
      {onDismiss && (
        <button
          onClick={onDismiss}
          style={closeButtonStyle}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = "0.7")}
          aria-label="Dismiss error"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 4L12 12M12 4L4 12"
              stroke="#D83B01"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;
